class DateService {
    secondsTimestampToLocalizedDateString(timestamp) {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return new Date(timestamp * 1000).toLocaleDateString("en-US", options);
    }

}

export default DateService